module.exports = __webpack_public_path__ + "img/group_del.8de65d36.svg";